import React from "react";
import {useForm, FormProvider} from "react-hook-form";
import {Link} from 'react-router-dom'

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';

import * as EmployerFragment from './EmployerFragmentComponent';
import * as CustomStyles from '../../styles/CustomStyles';
    

function EmployerFullRenderer(props) {
    const methods = useForm({
        defaultValues: {
            lEmployer: props.employer
        } 
    });

    const handleSubmit = methods.handleSubmit;

    const handleSubmitEData = (data) => {
        console.log('Current State is: ' + JSON.stringify(data));

        const employer = data.lEmployer;

        props.saveEmployer(employer);
    }


return(
        <React.Fragment>

        <FormProvider {...methods} > 
        <form onSubmit={handleSubmit( handleSubmitEData )} id={'eForm'}>

            {/**********   Date Generale   **********/}
            <EmployerFragment.RenderDateGeneraleSection 
                clients={props.clients}
            />

            {/**********   Adresa Sediu    **********/}
            <EmployerFragment.RenderAdresaSediuSection />

            {/**********   Puncte de Lucru    **********/}
            {(props.isNewEntity) ?
                ( <React.Fragment></React.Fragment>) 
                    :
                ( 
                <Box sx={CustomStyles.boxStyles} >
                    <div style={{display:"flex"}}>
                        <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Puncte&nbsp;de&nbsp;Lucru</Typography>

                        <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                            <Link to={`/worksite/${props.employer.id}`}>
                                <Button variant="outlined" sx={{ marginRight: 0.5 }} >Editeaza Puncte de Lucru</Button>
                            </Link>
                        </Box>
                    </div>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                    {( props.worksites == null) ? 
                        ( <React.Fragment></React.Fragment>) 
                            :
                        props.worksites.map((location) => (
                            <React.Fragment key={location.name}>
                                <Grid item xs={12}>
                                    <Tooltip 
                                        title={
                                        <React.Fragment>
                                        <Typography color="inherit"> {location.name} </Typography>
                                        <Typography color="inherit"> Judet: {location.judet}, Localitate: {location.localitate} </Typography>
                                        <Typography color="inherit"> Strada: {location.street}, Nr: {location.no} </Typography>
                                        </React.Fragment>
                                        }  
                                        followCursor
                                    >
                                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>{location.name}, {location.judet}, {location.localitate}</Typography>
                                    </Tooltip>
                                </Grid>
                            </React.Fragment>
                        ))}
                        </Grid>
                    </Box>
            )}

            {/**********   Date de Caracterizare    **********/}
            <EmployerFragment.RenderDateCaracterizareSection  />

            {/**********   Activitate Economica    **********/}
            <EmployerFragment.RenderActivitatiProtectieSection />

            {/**********   Medicina Muncii    **********/}
            <EmployerFragment.RenderMedicinaMunciiSection />

            {/**********   Preferinte    **********/}
            <EmployerFragment.RenderPreferenceSection />

            <Box sx={{ width:'100%', marginBottom: 2, marginTop: 1}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza Angajator</Button>
            </Box>

        </form>
        </FormProvider>


        </React.Fragment>

    );
}

export default EmployerFullRenderer;